import { Link } from 'react-router-dom';

interface ContentCardProps {
  id: number;
  title: string;
  category: string;
  excerpt: string;
  imageUrl: string;
  publishDate: string;
  rating?: number;
  slug: string;
}

export default function ContentCard({ id, title, category, excerpt, imageUrl, publishDate, rating, slug }: ContentCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          title={`${title} - 国产精品在线`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {rating && (
          <div className="absolute top-2 right-2 bg-background-950/70 backdrop-blur-sm text-accent-400 text-xs font-semibold px-2 py-0.5 rounded-full flex items-center gap-1">
            <i className="ri-star-fill text-[10px]"></i>
            {rating}
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
            {category}
          </span>
          <span className="text-xs text-foreground-400">{publishDate}</span>
        </div>
        <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-1">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {excerpt}
        </p>
      </div>
    </Link>
  );
}